import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'zone.js/dist/zone-error'; // provides enhanced stack traces in all environments.

import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';

import { AppComponent } from './app.component';
import { GlobalModule } from './global/global.module';
import { PageInfoService } from './layouts/page-info.service';
import { UnhandledErrorHandler } from './global/error-handling/unhandled-error-handler';
import { HomeModule } from './home/home.module';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { ReportsModule } from './reports/reports.module';
import { BlockUiModule } from './block-ui/block-ui.module';
import { AuthorizationGuard } from './authentication/authorization-guard';
import { GrantService } from './authentication/grant.service';
import { ErrorHandler } from './global/error-handling/error-handler';
import { AuthenticationService } from './authentication/authentication.service';
import { BasicAuthInterceptor } from './authentication/basic-auth-interceptor';
import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { QuotingServiceModule } from './quoting/quoting-service.module';
import { MessageService } from "primeng/api";
import { VersionService } from './version-service';
import { GoogleAnalyticsService } from './google-analytics/google-analytics.service';

@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		LogoutComponent
	],
	imports: [
		BrowserModule,
		FormsModule,
		GlobalModule,
		AppRoutingModule,
		LayoutsModule,
		HomeModule,
		ReportsModule,
		HttpClientModule,
		BrowserAnimationsModule,
		InputTextareaModule,
		InputTextModule,
		PasswordModule,
		BlockUiModule,
		QuotingServiceModule
	],
	providers: [
		HttpClient,
		PageInfoService,
		UnhandledErrorHandler,
		ErrorHandler,
		AuthorizationGuard,
		MessageService,
		GrantService,
		AuthenticationService,
		VersionService,
		GoogleAnalyticsService,
		{ provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true }
	],
	bootstrap: [
		AppComponent
	],
	exports: [
		AppComponent
	]
})
export class AppModule {

	constructor(
		private _AuthenticationService: AuthenticationService
	) {
		this._AuthenticationService.GetUserClaims();
	}

}